import { render, staticRenderFns } from "./ThreatsView.vue?vue&type=template&id=eb460e90&"
import script from "./ThreatsView.vue?vue&type=script&lang=ts&"
export * from "./ThreatsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports